//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_MatchSuspensionReminderMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_MatchSuspensionReminderMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_MatchSuspensionReminderMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    handleDataLoad: function() {
        return [
            { matchId: this._bridge.getRouteParam('id') },
            { matchId: this._bridge.getRouteParam('id'), suspend: 1 }
        ]
    }
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_MatchSuspensionReminderMediator, BaseMediator);

module.exports = tbs_controller_MatchSuspensionReminderMediator